import React from 'react'
import { useAuth } from '../components/AuthProvider'
import Analytics from '../components/Analytics'
import Reports from '../components/Reports'
import QuickActions from '../components/QuickActions'
import PortfolioOverview from '../components/PortfolioOverview'
import TradingSignals from '../components/TradingSignals'
import MarketData from '../components/MarketData'
import SmartContractInterface from '../components/SmartContractInterface'

const Dashboard = () => {
  const { user } = useAuth()

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
      <div className="mb-6 sm:mb-8">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
          Welcome back{user?.user_metadata?.full_name ? `, ${user.user_metadata.full_name}` : ', Trader'}!
        </h1>
        <p className="text-gray-600 text-sm sm:text-base">
          Monitor your portfolio, execute trades, and interact with smart contracts
        </p>
      </div>

      {/* Quick Actions */}
      <div className="mb-6 sm:mb-8">
        <QuickActions />
      </div>

      {/* Portfolio Overview */}
      <div className="mb-6 sm:mb-8">
        <PortfolioOverview />
      </div>

      {/* Trading Signals and Market Data */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 sm:gap-8 mb-6 sm:mb-8">
        <div className="order-1">
          <TradingSignals />
        </div>
        <div className="order-2">
          <MarketData />
        </div>
      </div>

      {/* Smart Contract Interface */}
      <div className="mb-6 sm:mb-8">
        <SmartContractInterface />
      </div>

      {/* Analytics and Reports Grid */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 sm:gap-8">
        <div className="order-1">
          <Analytics />
        </div>
        <div className="order-2">
          <Reports />
        </div>
      </div>
    </div>
  )
}

export default Dashboard